import CountryList from './country.list';

export const CountryStores = {
  list: CountryList,
};
